import ViewAllIcon from '@/assets/icon/viewAllIcon.svg'
const ViewAll = () => {
  return <ViewAllIcon />;
};
export default ViewAll;
